const adminCreationDes = {
    text: "Δημιουργία Διαχειριστή",
    title: "Εγγραφή νέου διαχειριστή ΔΕΠΕΘ",
    to: "/register-des",
}

const announcementsDes = {
    text: "Ανακοινώσεις ΓΕΣ/Α4 (ΔΕΠΕΘ)",
    title: "Εμφάνιση Ανακοινώσεις ΔΕΠΕΘ",
    to: "/desannouncements",
}
const createAnnouncement = {
    text: "Δημιουργία Ανακοίνωσης",
    title: "Δημιουργία νέας ανακοίνωσης ΔΕΠΕΘ",
    to: "/create-announcement",
}

const showAdminsDes = {
    text: "Εμφάνιση Διαχειριστών",
    title: "Εμφάνιση Διαχειριστών ΔΕΠΕΘ",
    to: "/des-users",
}

const adminCreationDeps = {
    text: "Δημιουργία Διαχειριστή ΔΕΠΣ",
    title: "Εγγραφή Νέου Διαχειριστή ΔΕΠΣ",
    to: "/register-sxhmatismos",
}

const announcementsDeps = {
    text: "Ανακοινώσεις ΔΕΠΣ",
    title: "Ανάγνωση Ανακοινώσεων ΔΕΠΣ",
    to: "/depsannouncements",
}

const showAdminsDeps = {
    text: "Εμφάνιση Διαχειριστών ΔΕΠΣ",
    title: "Εμφάνιση Διαχειριστών ΔΕΠΣ",
    to: "/deps-users",
}

const adminCreationMe = {
    text: "Δημιουργία Διαχειριστή ΜΕ",
    title: "Δημιουργία Νέου Διαχειριστή ΜΕ",
    to: "/register-me",
}

const announcementsMe = {
    text: "Ανακοινώσεις ΜΕ",
    title: "Ανάγνωση ανακοινώσεων ΜΕ",
    to: "/meannouncements",
}

const showAdminsMe = {
    text: "Εμφάνιση Διαχειριστών ΜΕ",
    title: "Εμφάνιση Διαχειριστών ΜΕ",
    to: "/me-users",
}

const revTeams = {
    text: "Ομάδες Εφέδρων",
    title: "Εμφάνιση Ομάδων Εφέδρων",
    to: "/teams",
}

const createTeam = {
    text: "Δημιουργία Ομάδας",
    title: "Δημιουργία Νέας Ομάδας Εφέδρων",
    to: "/create-team",
}

export const userDetailsAdmin = {
    text: "Εφεδρικό Δυναμικό",
    title: "Διαχείριση Εφέδρων",
    to: "/user-details-admin",
    isDropdown: false
}

export const gesFunctionalities = {
    text: "Λειτουργίες ΓΕΣ/Α4 (ΔΕΠΕΘ)",
    title: "Λειτουργίες ΓΕΣ/Α4 (ΔΕΠΕΘ)",
    isDropdown: true,
    dropdownProperties: [
        adminCreationDes,
        announcementsDes,
        createAnnouncement,
        showAdminsDes
    ]
}

export const depsFunctionalities = {
    text: "Λειτουργίες ΔΕΠΣ",
    title: "Λειτουργίες ΔΕΠΣ",
    isDropdown: true,
    dropdownProperties: [
        adminCreationDeps,
        announcementsDeps,
        showAdminsDeps
    ]
}

export const meFunctionalities = {
    text: "Λειτουργίες ΜΕ",
    title: "Λειτουργίες ΜΕ",
    isDropdown: true,
    dropdownProperties: [
        adminCreationMe,
        announcementsMe,
        showAdminsMe
    ]
}

export const changeTable = {
    text: "Πίνακας Μεταβολών",
    title: "Πίνακας Μεταβολών",
    to: "/changes-table",
    isDropdown: false
}

export const validateAnnouncementsDeps = {
    text: "Έγκριση Ανακοίνωσης ΔΕΠΣ",
    title: "Έγκριση Ανακοινώσεων που Δημοσιεύτηκαν από ΔΕΠΣ",
    to: "/validate-announcement-deps",
    isDropdown: false
}

export const validateAnnouncementsMe = {
    text: "Έγκριση Ανακοίνωσης ΜΕ",
    title: "Έγκριση Ανακοινώσεων που Δημοσιεύτηκαν από ΜΕ",
    to: "/validate-announcement-me",
    isDropdown: false
}

export const diavImport = {
    text: "Εισαγωγή Δεδομένων",
    title: "Εισαγωγή Δεδομένων",
    to: "/diav-import",
    isDropdown: false
}

export const createAnnouncementMe = {
    text: "Δημιουργία Ανακοίνωσης ΜΕ",
    title: "Δημιουργία Ανακοίνωσης ΜΕ",
    to: "/create-announcement",
    isDropdown: false
}

export const announcementsManager = {
    text: "Ανακοινώσεις",
    title: "Ανακοινώσεις",
    isDropdown: true,
    dropdownProperties: [
        announcementsMe,
        announcementsDes
    ]
}

export const teams = {
    text: "Ομάδες",
    title: "Ομάδες",
    isDropdown: true,
    dropdownProperties: {
        revTeams,
        createTeam
    },
}

export const announcementsSxhmatismos = {
    text: "Ανακοινώσεις",
    title: "Ανακοινώσεις",
    isDropdown: true,
    dropdownProperties: [
        announcementsDeps,
        announcementsDes
    ]
}

export const allAdmins = {
    text: "Διαχειριστές Εφαρμογής",
    title: "Διαχειριστές Εφαρμογής",
    to: "/manage-all-admins",
}

//************ User Menu Components ************//
export const userDetails = {
    text: "Ατομικά Στοιχεία",
    title: "Ενημέρωση / προσθήκη ατομικών στοιχείων",
    to: "/user-details"
}

export const kanonismoi = {
    text: "ΣΔΗΜ",
    title: "ΣΔΗΜ",
    to: "/kanonismoi"
}

export const announcements = {
    text: "Ανακοινώσεις",
    title: "Ανάγνωση Ανακοινώσεων",
    to: "/announcements"
}

export const activeReserve ={
    text: "Ενεργή Εφεδρεία",
    title: "Ενεργή Εφεδρεία",
    to: "/reserve"
}

export const contactMe = {
    text: "Επικοινωνία με ΜΕ",
    title: "Επικοινωνία με Μονάδα Επιστρατεύσεως",
    to: "/contact-me"
}

export const generateEfp = {
    text: "Εκτύπωση \nΕιδικού Φύλλου Πορείας",
    title: "Εκτύπωση Ειδικού Φύλλου Πορείας",
    to: "generate-efp"
}

export const generateValidation = {
    text: "Εκτύπωση \nΒεβαίωσης Εγγραφής",
    title: "Εκτύπωση Βεβαίωσης",
    to: "/generate-validation"
}